module.exports = __webpack_public_path__ + "img/a6p4e-vve3i.3663b43b.png";